import { colors } from "theme/palette";

import Tabs, { Tab } from "components/Tabs";

import { TABS } from "./constants";

interface IMemoTabs<T extends string> {
  selectedTab: string;
  onChange: (event: any, tabIndex: T) => void;
}

const MemoTabs = <T extends string>({
  selectedTab,
  onChange,
}: IMemoTabs<T>) => (
  <Tabs
    value={selectedTab}
    onChange={onChange}
    TabIndicatorProps={{ sx: { height: "4px" } } as any}
    data-testid="checklist-tabs"
    sx={{
      marginBottom: 3,
      borderBottom: `1px solid ${colors.blue100}`,
    }}
  >
    {TABS.map(({ label, value }) => (
      <Tab
        key={value}
        sx={{
          textTransform: "none",
          color: colors.gray100,
          padding: "9px 1.5em",
          fontSize: "16px",
          "&.Mui-selected": {
            color: colors.gray100,
            backgroundColor: colors.blue20,
          },
        }}
        label={label}
        value={value}
        data-testid="checklist-tab"
      />
    ))}
  </Tabs>
);

export default MemoTabs;
